/* ADSCALAR — wishlist drawer. New 2026-09-06 (bug audit fix).

   Renders from the same `ek_wishlist` localStorage list the card/PDP heart
   buttons write to (asc-pages.js / asc-pdp.js). Each entry carries a full
   {id,title,url,img,price} snapshot captured at heart-time — bare product IDs
   can't be turned back into a card client-side, which is why that storage
   format changed alongside this. Legacy bare-string entries saved before that
   change carry no renderable data and are skipped rather than shown broken. */
(function () {
  var KEY = 'ek_wishlist';
  var root = document.querySelector('[data-asc-wl-root]');
  if (!root) return;

  var panel = root.querySelector('[data-asc-wl]');
  var scrim = root.querySelector('[data-asc-wl-scrim]');
  var grid = root.querySelector('[data-asc-wishlist-grid]');
  var empty = root.querySelector('[data-asc-wishlist-empty]');
  var isOpen = false;
  var lastFocused = null;

  function esc(s) {
    return ('' + (s || '')).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/"/g, '&quot;');
  }

  function getWish() {
    try {
      var list = JSON.parse(localStorage.getItem(KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function render() {
    // Same card markup as snippets/asc-card.liquid, including a live wishlist
    // heart (pre-marked "on") so clicking it removes the item through
    // asc-pages.js's existing document-level delegated handler — that fires
    // 'ek:wishlist-change', which re-runs this render and drops the card.
    var items = getWish().filter(function (e) { return e && typeof e === 'object' && e.id; });

    if (items.length === 0) {
      grid.innerHTML = '';
      empty.hidden = false;
      return;
    }
    empty.hidden = true;

    grid.innerHTML = items.map(function (p) {
      return '' +
        '<article class="asc-card">' +
          '<div class="asc-card-media">' +
            '<a href="' + esc(p.url) + '" aria-label="' + esc(p.title) + '">' +
              (p.img ? '<img class="asc-card-img1" src="' + esc(p.img) + '" width="480" height="600" loading="lazy" alt="">' : '') +
            '</a>' +
            '<button class="asc-card-wish on" type="button" data-asc-card-wish data-pid="' + esc(p.id) + '" ' +
              'data-title="' + esc(p.title) + '" data-url="' + esc(p.url) + '" data-img="' + esc(p.img) + '" data-price="' + esc(p.price) + '" ' +
              'aria-label="Remove from wishlist" aria-pressed="true">' +
              '<svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>' +
            '</button>' +
          '</div>' +
          '<a class="asc-card-info" href="' + esc(p.url) + '">' +
            '<span class="asc-card-title">' + esc(p.title) + '</span>' +
            '<span class="asc-card-prices"><span class="asc-card-price tabular">' + esc(p.price) + '</span></span>' +
          '</a>' +
        '</article>';
    }).join('');
  }

  function openDrawer() {
    if (isOpen) return;
    isOpen = true;
    lastFocused = document.activeElement;
    render();
    root.classList.add('open');
    panel.setAttribute('aria-hidden', 'false');
    if (scrim) scrim.classList.add('open');
    document.body.classList.add('scroll-locked');
    var closeBtn = panel.querySelector('[data-asc-wl-close]');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function closeDrawer() {
    if (!isOpen) return;
    isOpen = false;
    root.classList.remove('open');
    panel.setAttribute('aria-hidden', 'true');
    if (scrim) scrim.classList.remove('open');
    document.body.classList.remove('scroll-locked');
    if (lastFocused && lastFocused.focus) lastFocused.focus({ preventScroll: true });
  }

  document.addEventListener('click', function (e) {
    // Header heart opens the drawer instead of navigating.
    var opener = e.target.closest('[data-asc-wishlink]');
    if (opener) { e.preventDefault(); openDrawer(); return; }

    var closeEl = e.target.closest('[data-asc-wl-close]');
    if (closeEl) {
      // Links inside (e.g. "Start shopping") should still navigate.
      if (!e.target.closest('a[data-asc-wl-close]')) e.preventDefault();
      closeDrawer();
      return;
    }
    if (scrim && e.target === scrim) closeDrawer();
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen) closeDrawer();
  });

  window.addEventListener('ek:wishlist-change', function () { if (isOpen) render(); });
  window.addEventListener('storage', function (e) { if (e.key === KEY && isOpen) render(); });

  window.ekWishlist = { open: openDrawer, close: closeDrawer };
})();
